import _ from 'lodash';
import { useEffect, useMemo } from 'react';

export default function useDebounce<T extends ReadonlyArray<unknown>, R>(
  func: (...arg: T) => R,
  wait: number,
  deps: ReadonlyArray<unknown> = [],
) {
  const dependencies = [...deps, wait];
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoized = useMemo(() => _.debounce(func, wait), dependencies);

  useEffect(
    () => () => {
      memoized.cancel();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    dependencies,
  );

  return memoized;
}
